import React from 'react';
import { useTranslation } from 'react-i18next';

import ProjectInfoPanel from 'components/ProjectInfoPanel/ProjectInfoPanel';
import LinkButton from 'components/LinkButton/LinkButton';
import SideBar from 'components/SideBar/SideBar';
import { BooksLibraryIcon } from 'components/SvgIcons';
import { useSelector } from 'store';
import TraroElement from 'types/api/TraroElement';
import useDaysBefore from 'hooks/useDaysBefore';

import './ProsforaElementSideBar.scss';

export interface ProsforaElementSideBarProps {
  element: TraroElement;
}

const ProsforaElementSideBar = ({ element }: ProsforaElementSideBarProps) => {
  const { t } = useTranslation();
  const { id: rfpId, response_close_date, is_response_open } = useSelector((state) => state.rfp.data);

  const daysLeft = useDaysBefore(response_close_date);
  const biddingStatus = is_response_open ? 'Open' : 'Closed';

  return (
    <SideBar variant="prosfora" collapsible className="enkrateia-prosfora-element-side-bar">
      <div className="side-bar-content">
        <ProjectInfoPanel
          variant="prosfora"
          label={t('pages.prosforaElement.sidePanel.issuanceName')}
          value={element.element_name}
        />
        <div className="middle-panels">
          <ProjectInfoPanel
            variant="prosfora"
            label={t('pages.prosforaElement.sidePanel.issuanceYear')}
            value={element.context0}
          />
          <ProjectInfoPanel
            variant="prosfora"
            label={t('pages.prosforaElement.sidePanel.totalVolume')}
            value={element.context1}
          />
        </div>
        <div className="middle-panels">
          <ProjectInfoPanel
            variant="prosfora"
            label={t('pages.prosforaElement.sidePanel.biddingStatus')}
            value={t(`pages.prosforaElement.sidePanel.biddingStatus${biddingStatus}`)}
          />
          <ProjectInfoPanel
            variant="prosfora"
            withBorder
            label={t('pages.prosforaElement.sidePanel.daysRemaining')}
            value={daysLeft}
          />
        </div>
        <LinkButton variant="tertiary-filled" to={`/rfp/${rfpId}/data-room`}>
          <BooksLibraryIcon size={32} color="white" />
          <span className="link">{t('pages.prosforaElement.sidePanel.auctionDataRoom')}</span>
        </LinkButton>
      </div>
    </SideBar>
  );
};

export default ProsforaElementSideBar;
